import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AmenitiesSearchHandler } from '@sabstravtech/obtservices/base';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';

import { LightningModalTypes } from '../../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-hotel-facilities',
  templateUrl: './hotel-facilities.component.html',
  styleUrls: ['./hotel-facilities.component.scss'],
  standalone: false
})
export class HotelFacilitiesComponent implements OnInit {
  hotel: any = null;
  AmenitiesSearchHandler = AmenitiesSearchHandler;
  faLeaf = faLeaf;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}

LightningModalTypes.HotelFacilitiesComponent.component = HotelFacilitiesComponent;
